(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vivolan-sticky-offer"] && !Shopify.designMode) return;
  try {
    
        window.addEventListener('scroll', function() {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var scrollHeight = document.documentElement.scrollHeight;
    var clientHeight = document.documentElement.clientHeight;
    var scrollPercent = (scrollTop / (scrollHeight - clientHeight)) * 100;

    var stickyButton = document.querySelector('.sticky-button');
    if (scrollPercent > 40 && scrollPercent < 90) {
        stickyButton.classList.add('visible');
    } else {
        stickyButton.classList.remove('visible');
    }
});

  } catch(e) { console.error(e); }
})();
})();
